import { TableRow } from "@aws-amplify/ui-react";
import { Box, TableBody, TableCell, Typography } from "@mui/material";
import { TableCellBody } from "@src/components";
import React from "react";
import { TopPositionsTableBodyData } from "./components/TopPositinosTable.Body.Data";
import {
  PopularProductModel,
  ProductsModel,
} from "../../domain/models/PopularProductModel";

interface TopPositionsTableProps {
  data: ProductsModel[];
}

export const TopPositionsTableBody: React.FC<TopPositionsTableProps> = (
  props
) => {
  const { data } = props;

  return (
    <TableBody>
      {data.map((position) => {
        return (
          <TopPositionsTableBodyData
            position={position}
            key={position.productName}
          />
        );
      })}
    </TableBody>
  );
};